import { useState } from "react";
import { Button } from "../../../components/Button";

const SearchBar = ({
  setSearchTerm,
  currentSearch,
}: {
  currentSearch: string;
  setSearchTerm: (s: string) => void;
}) => {
  const [value, setValue] = useState<string>("");
  return (
    <form className="flex text-xs">
      <div className="relative h-full">
        <input
          value={value}
          onChange={(e) => setValue(e.target.value)}
          className="border border-[#B3B3B3] w-48 h-full px-3 outline-none focus:border-primaryColor"
          placeholder="Enter keyword or date"
        />
        {currentSearch.length > 0 && (
          <button
            onClick={(e) => {
              e.preventDefault();
              setSearchTerm("");
              setValue("");
            }}
            className="transition absolute right-0 h-full top-0 grid content-center px-3 opacity-50 hover:opacity-80"
          >
            <i className="icon-close font-black text-xs" />
          </button>
        )}
      </div>
      <Button
        className="grid content-center px-3"
        onClick={(e) => {
          e.preventDefault();
          setSearchTerm(value.toLowerCase());
        }}
      >
        Search
      </Button>
    </form>
  );
};

export { SearchBar };
